import React, { Component } from "react";
import { Markup } from "interweave";
import Radio from '@mui/material/Radio';
import {Checkbox} from "@mui/material";

class MCViewer extends Component {
  state = {
    Question_ID: this.props.Question_ID,
    Question_Answers: this.props.Question_Answers,
    Response_Required: this.props.Response_Required,
    Answer_ID: this.props.Answer_ID ? this.props.Answer_ID : 0,
    isScale: this.props.isScale,
    isMultiple: this.props.isMultiple,
    SurveyMode: this.props.SurveyMode,
    preloadQAData: this.props.preloadQAData ? this.props.preloadQAData : {},
  };

  constructor(props) {
    super(props);
    let preloadQAData = this.state.preloadQAData, Response_Required = this.state.Response_Required, qID = this.state.Question_ID;
    this.state.Question_Answers.filter(function (item) {
      if (preloadQAData['Answer_Text'] && preloadQAData['Answer_Text'].includes(item['Answer_Text'])) {
        item['isChecked'] = true;
        props.OnUpdate(props.Question_Number, {
          Responses: [
            { Question_ID: qID, Answer_ID: preloadQAData.Answer_ID, Answer_Text: preloadQAData.Answer_Text, Question_Number: props.Question_Number }
          ],
          Response_Required: Response_Required,
        });
      }
      else {
        item['isChecked'] = false;
      }
      return item;
    })
  }

  handleSelection = ({ target }) => {
    if (this.state.SurveyMode) {
      let Answer_ID = parseInt(target.value);
      //Deselection
      let isMultiple = this.state.isMultiple,
        Question_Answers = this.state.Question_Answers
      Question_Answers.filter(function (item) {
        if (item['Answer_ID'] === Answer_ID) {
          item['isChecked'] = !item['isChecked']
        }
        else if (!isMultiple) {
          item['isChecked'] = false
        }
        return item
      })
      this.setState({ ...this.state, Question_Answers })
      this.props.OnUpdate(this.props.Question_Number, {
        Responses: [
          {
            Question_ID: this.state.Question_ID,
            Answer_ID: Answer_ID,
            Answer_Text: (this.state.Question_Answers).filter(item => (item['isChecked'])).map(ans => ans['Answer_Text']),
            Question_Number:this.props.Question_Number
          }
        ],
        Response_Required: this.state.Response_Required,
      });
      this.setState({ Answer_ID });
    }
  };

  render() {
    const { Question_Answers, isScale, Question_ID, isMultiple } = this.state;
    return (
      <div className="form-group mb-0">
        {Question_Answers.map((ans) => {
          return (
            <div
              className={"form-check" + (isScale ? " form-check-inline" : "")}
              key={Question_ID + "-" + ans.Answer_ID}
            >
              {isMultiple ?
                <Checkbox
                  key={"mc" + ans.Answer_ID}
                  disabled={this.props.disabled}
                  value={ans.Answer_ID}
                  id={'MC' + ans.Answer_ID}
                  onChange={this.handleSelection}
                  checked={ans.isChecked}
                  size="small"
                />
                :
                <Radio
                    key={"mc" + ans.Answer_ID}
                    disabled={this.props.disabled}
                    value={ans.Answer_ID}
                    id={'MC' + ans.Answer_ID}
                    onChange={this.handleSelection}
                    checked={ans.isChecked}
                    size="small"
                />
              }
              <label htmlFor={'MC' + ans.Answer_ID} className="form-check-label">
                <Markup content={ans.Answer_Text} />
              </label>
            </div>
          );
        })}
      </div>
    );
  }
}

export default MCViewer;
